module.exports = __webpack_public_path__ + "img/gate-rail-vertical.71a44852.png";